var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIsotipoRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.7814 13.2669C18.4576 12.4089 18.2846 11.487 18.2846 10.527C18.2846 8.42695 19.1194 6.50897 20.5 5.04697C17.8346 5.36297 15.5397 6.77496 14.149 8.78496C14.1225 8.82696 14.0919 8.86894 14.0655 8.91094C14.0675 8.85894 14.0675 8.80493 14.0675 8.75293C14.0695 8.72093 14.0695 8.68893 14.0695 8.65493C14.0695 5.94893 12.6788 2.30497 10.5285 0.792969C8.37823 2.30497 6.98748 5.94693 6.98748 8.65493C6.98748 8.68893 6.98748 8.72093 6.98951 8.75293C6.98748 8.78693 6.98951 8.81893 6.99155 8.85293C6.97322 8.82693 6.95286 8.80095 6.93453 8.77495C5.52952 6.74695 3.19802 5.33097 0.5 5.03896C1.90501 6.50697 2.76227 8.44495 2.76227 10.5689C2.76227 11.4849 2.60344 12.363 2.30818 13.187C2.23895 13.383 2.16158 13.5749 2.07809 13.7649C1.79913 14.5549 1.64233 15.397 1.63215 16.275V16.3709C1.63215 18.0349 2.15547 19.583 3.05752 20.881C3.56048 21.605 4.18153 22.249 4.89422 22.793C4.59896 22.455 1.8989 19.107 6.39493 14.083C6.39493 14.083 5.78202 20.0809 9.39432 19.7009C11.2086 19.5089 11.7075 18.159 10.9806 16.739C9.72216 14.281 7.84066 10.7169 11.5548 7.45493C11.5548 7.45493 10.331 12.291 13.7621 14.631C16.2707 16.343 18.1787 18.6889 16.1933 22.7729C16.8999 22.2289 17.5149 21.5849 18.0137 20.8649C18.9097 19.5709 19.431 18.0269 19.431 16.3689V16.2729C19.4188 15.3529 19.2457 14.469 18.9402 13.643C18.8853 13.519 18.8344 13.3949 18.7896 13.2689L18.7814 13.2669Z",
    fill: "url(#paint0_linear_64_5208)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_5208",
    x1: 10.4998,
    y1: 0.792969,
    x2: 10.4998,
    y2: 22.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66140E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E42320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E04E11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsotipoRed);
export default __webpack_public_path__ + "static/media/isotipo-red.9281df1891364d75c17f8c91497ee312.svg";
export { ForwardRef as ReactComponent };